import React from "react";
import "./PatientRecord.css";
import Navbar from "../Navbar/Navbar";
import PatientRecordHead from "./PatientRecordHead";
import PatientRecordTabs from "./PatientRecordTabs";

function PatientRecord(props) {
  console.log(props);
  return (
    <div>
      <Navbar />
      <div className="container">
        <PatientRecordHead props={props} />
        <PatientRecordTabs />
      </div>
    </div>
  );
}

export default PatientRecord;
